import { BackendResponseFormat } from "../utils/fetch";
import { BackendError } from "./BackendError";

export class NotFoundError extends BackendError {
  constructor(responseBody: BackendResponseFormat<unknown> | string) {
    super(404, responseBody);
    this.name = "NotFoundError";
  }
}
